(() => {
  const end = Date.parse('2026-10-26T03:00:00Z');
  const pad = (n) => String(n).padStart(2, '0');
  function update() {
    const seconds = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const values = {days:Math.floor(seconds/86400), hours:Math.floor(seconds/3600)%24, minutes:Math.floor(seconds/60)%60, seconds:seconds%60};
    document.querySelectorAll('[data-auv-sale-timer]').forEach((timer) => {
      if (seconds === 0) { timer.remove(); return; }
      for (const [unit,value] of Object.entries(values)) {
        const node = timer.querySelector('[data-auv-unit="'+unit+'"]');
        const text = pad(value);
        if (node && node.textContent !== text) node.textContent = text;
      }
    });
  }
  function mountEssential() {
    const portal = document.getElementById('essential-cart-drawer-portal');
    const dialog = portal?.querySelector('[role="dialog"][aria-labelledby="cart-drawer-title"]');
    if (!dialog || dialog.querySelector('[data-auv-sale-timer]') || Date.now() >= end) return;
    const source = document.querySelector('[data-auv-sale-timer]');
    if (!source) return;
    const timer = source.cloneNode(true);
    timer.dataset.auvEssentialTimer = 'true';
    const header = dialog.firstElementChild;
    if (header) header.after(timer); else dialog.append(timer);
    update();
  }

  function syncStickyPrice() {
    const portal = document.getElementById('sticky-cart-portal');
    const main = document.querySelector('main[data-template="product"]');
    const source = main?.querySelector('product-price [ref="priceContainer"]');
    if (!portal || !source) return;
    const selected = main.querySelector('product-form-component input[name="id"]');
    const sticky = portal.querySelector('[data-variant-id]');
    if (selected?.value && sticky?.dataset.variantId && selected.value !== sticky.dataset.variantId) return;
    const prices = source.querySelectorAll(':scope > .price, :scope > .compare-at-price');
    if (!prices.length) return;
    const wrapper = document.createElement('span');
    wrapper.dataset.auvStickyPrice = 'true';
    wrapper.style.cssText = 'display:inline-flex;flex-wrap:wrap;align-items:center;gap:6px;color:inherit;font-size:inherit';
    prices.forEach((price) => {
      const copy = price.cloneNode(true);
      copy.style.cssText = price.classList.contains('compare-at-price')
        ? 'color:inherit;font-size:inherit;text-decoration:line-through;opacity:.75'
        : 'color:inherit;font-size:inherit;font-weight:600';
      wrapper.append(copy);
    });
    const html = wrapper.outerHTML;
    portal.querySelectorAll('[data-essential-cart-element="price"]').forEach((target) => {
      if (target.innerHTML !== html) target.innerHTML = html;
    });
  }

  function start() {
    update(); mountEssential(); syncStickyPrice();
    setInterval(() => { mountEssential(); update(); syncStickyPrice(); }, 1000);
    document.addEventListener('essential-cart:open', mountEssential);
    document.addEventListener('shopify:section:load', () => { update(); mountEssential(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
